// extracted by mini-css-extract-plugin
export default {"playersContainer":"kf0nWvKrSTYGnR0AOQM1","playerWrapper":"jSWROWpEyKVEDeJTgxuU","avatar":"HwYTgC6K54sfDuvmU68q","statusIcon":"nb9VgeeJ6rdTcrd0YxUj"};